<template>
  <div id="app">
    <el-container class="service-page-qiangzhi-buxudong">
      <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no">
      <el-main class="service-main">
        <div class="service-head-background">
          <el-row>
            <el-col class="service-head-title" :xs="24" :sm="2" :md="2">综合</el-col>
            <el-col class="service-head-input" :xs="24" :sm="2" :md="3">
              <el-input
                  placeholder="请输入关键字"
                  v-model="input"
                  clearable>
              </el-input>
              <a @click="input_sj(input)" class="search-logo">
                <img  src="../../../assets/home/sousuo_logo.png" alt="">
              </a>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="15">

          <el-col :xs="24" :sm="12" :md="6"  v-for="(item,index) in videozhi" v-bind:key="index">
<!--            <a v-bind:href="'#/college/video/'+ item.id">-->
            <a v-bind:href="'#/video_details/'+ item.id">
            <div class="service-main-background">
              <el-image class="service-main-picture" :src="url+'/storage/'+item.pic" fit="cover" >
                <div slot="error" class="image-slot">
                  <img src="../../../assets/wenzhangfengmian.png" alt="" >
                  <!--                        <i class="el-icon-picture-outline"></i>-->
                </div>
              </el-image>
              <div class="service-main-background-title">{{item.title}}</div>
              <div class="service-main-background-time">{{item.updated_at}}</div>
            </div>
            </a>
          </el-col>

        </el-row>
        <div data-v-6af373ef="" class="el-pagination is-background" style="margin-left: -20px;margin-top: 40px">
          <span class="el-pagination__total">共 {{ zongshu }} 条</span>
          <el-pagination
              style="float: left;margin-bottom: 150px"
              layout="prev, pager, next"
              @current-change="yedianji"
              :total="yemashu*10">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "category",
  data: function () {
    return {
      url:'',
      videozhi:'',
      input:'',
      yemashu:'',
      zongshu:'',
      yemazhi:1,
      searchValue:'',
      id:'',
    }
  },
  methods: {

    init(){
      var t = this
      this.information = this.$store.state.information
      t.id = t.$route.params.id
      if (t.$store.state.shopsSearchValue){
        t.searchValue = t.$store.state.shopsSearchValue
      }
      if (t.searchValue){
        t.input = t.searchValue
      }
      this.list_data()
      this.url = window.config.api_url
      // this.dp_inform()

    },
    input_sj(e){
      var t = this
      t.input = e
      t.list_data()
    },
    yedianji(e){
      this.yemazhi = e
      this.init()
    },
    list_data(){
      var t = this
      var url = window.config.api_url+'/college/video?shop_id='+t.id
      if (t.input){
        url += '&keywords='+t.input
      }
      if (t.yemazhi){
        url = url+'&page='+t.yemazhi
      }
      t.axios.get(url).then(res=>{
        t.videozhi = res.data.list.data
        t.yemashu = res.data.list.last_page
        t.zongshu = res.data.list.total
      })
    },
    fujiaxz(e){
      this.$router.push(this.url+'/storage/'+e);
    },
    handleChange2(e){
      this.$store.commit('savePath',e)
    }
  },
  created() {
    this.init()
  },
  watch:{
    '$store.state.shopsSearchValue'() {
      if(this.$store.state.information!==this.searchValue){
        this.init()
      }
    }
  }
}
</script>
<style>
.el-input__inner{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.el-input--suffix .el-input__inner{
  border: 0px;
  width: 133px;
  height: 27px;
  background: #E1E1E1;
  border-radius: 5px;
}
</style>
<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
@head_text : Source Han Sans CN;
@font-face {

}
//@import "../../../assets/css/home";
@import "../../../assets/css/shops_video";
</style>
<style lang="less" scoped>
@font-face {

}
</style>
